import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Container } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DrawerHeader } from "../../components/layout/Drawer/DrawerMain";
import PreferencesRouter from "../../routes/PreferencesRouter";
import Meta from "../../components/common/Meta";
import { useLoginStatus } from "../../context/LoginStatusContext";

export default function Preferences() {
  const { t } = useTranslation();
  const location = useLocation();
  const { user } = useLoginStatus();

  // タブ位置を定数として定義
  const TAB_POSITIONS = {
    ACCOUNT: 0,
    PLAN_AND_BILLINGS: 1,
    SETTINGS: 2,
    ENTERPRISE: 3,
    MISC: 4,
  };

  // 組織アカウント用のタブ位置
  const ENTERPRISE_TAB_POSITIONS = {
    ACCOUNT: 0,
    // PLAN_AND_BILLINGSは非表示なので含まない
    SETTINGS: 1,
    ENTERPRISE: 2,
    MISC: 3,
  };

  const currentTab = (() => {
    const path = location.pathname.split("/").pop();
    const isEnterprise = user?.user_type === "enterprise";
    const positions = isEnterprise ? ENTERPRISE_TAB_POSITIONS : TAB_POSITIONS;

    switch (path) {
      case "account":
        return positions.ACCOUNT;
      case "plan-and-billings":
        // エンタープライズモードではこのタブは表示されないため、直接値を返す
        return isEnterprise ? 0 : TAB_POSITIONS.PLAN_AND_BILLINGS;
      case "settings":
        return positions.SETTINGS;
      case "enterprise":
        return positions.ENTERPRISE;
      case "misc":
        return positions.MISC;
      default:
        return positions.ACCOUNT;
    }
  })();

  return (
    <>
      <Meta title={t("preferences.title")} meta={[{ name: "robots", content: "noindex, nofollow" }]} />
      <Container maxWidth="lg">
        <DrawerHeader />
        <Typography component={"h2"} variant="h4" gutterBottom my={2}>
          {t("preferences.title")}
        </Typography>
        <Box component="div" sx={{ marginTop: { xs: 1, sm: 2 } }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs value={currentTab} scrollButtons="auto" variant="scrollable">
              <Tab label={t("preferences.account.title")} component={Link} to="account" />
              {user?.user_type !== "enterprise" && (
                <Tab label={t("preferences.planAndBillings.title")} component={Link} to="plan-and-billings" />
              )}
              <Tab label={t("preferences.settings.title")} component={Link} to="settings" />
              {user?.has_enterprise_memberships && (
                <Tab label={t("preferences.enterprise.title")} component={Link} to="enterprise" />
              )}
              <Tab label={t("preferences.misc.title")} component={Link} to="misc" />
            </Tabs>
          </Box>

          <PreferencesRouter />
        </Box>
      </Container>
    </>
  );
}
